import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash/fp';
import { InventorySnapshotType } from '../../interfaces/reservation';

const ItemGroup = styled.div`
  max-width: 400px;
  padding: 3px 0;
`;

const ItemLabel = styled.label`
  width: 75px;
  display: inline-block;
  text-transform: none;
  font-size: 12px;
  margin-right: 10px;
  font-weight: normal;
  color: #8e8e93;
`;

const ItemValue = styled.div`
  display: inline-block;
  text-align: left;
  text-transform: none;
  font-size: 13px;
  font-weight: normal;
`;

const LinkedInventoryDetails = ({ snapshot: { item, location, zone } }) => (
  <ItemGroup key="inventorySnapshot" style={{ margin: '10px 0' }}>
    <ItemLabel>Linked Item:</ItemLabel>
    <ItemValue>
      {get('name', item)}
      <em>
        {` - ${get('name', location)}`}
        {get('name', zone) ? `, ${get('name', zone)}` : ''}
      </em>
    </ItemValue>
  </ItemGroup>
);

LinkedInventoryDetails.propTypes = {
  snapshot: InventorySnapshotType.isRequired
};

export default LinkedInventoryDetails;
